import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SocialService from "../../services/SocialService";

const EditSocial = (props) => {
  const { id } = useParams();
  let navigate = useNavigate();

  const initialSocialState = {
    id: null,
    name: "",
    link: "",
    published: false,
  };

  const [currentSocial, setCurrentSocial] = useState(initialSocialState);
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [image, setImage] = useState(null);

  const getSocial = (id) => {
    SocialService.get(id)
      .then((response) => {
        setCurrentSocial(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (id) getSocial(id);
  }, [id]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCurrentSocial({ ...currentSocial, [name]: value });
  };

  const updateSocial = () => {
    SocialService.update(currentSocial.id, currentSocial)
      .then((response) => {
        setMessage("The Social was updated successfully!");
        setSubmitted(true);
        // console.log(currentSocial)
      })
      .catch((e) => {
        console.log(e.response.data.message);
        setMessage("Error: " + e.response.data.message);
        setSubmitted(true);
      });
  };

  const deleteSocial = () => {
    SocialService.remove(currentSocial.id)
      .then((response) => {
        console.log(response.data);
        navigate("/admin/social");
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <div className="container pb-10">
      {currentSocial ? (
        <>
          <h1 className="text-1xl lg:text-1xl font-semibold py-10">
            {" "}
            Edit {currentSocial.name}
          </h1>
          <div>
            {submitted ? (
              <div
                className="bg-green-100 border border-green-700 text-clay-500 px-4 py-3 rounded relative"
                role="alert"
              >
                <p style={{ marginBottom: "0" }}>{message}</p>
              </div>
            ) : (
              <>
                <p style={{ marginBottom: "0" }}>{message}</p>
              </>
            )}
            <br></br>
          </div>

          <form className="w-full">
            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3">
                <label
                  className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                  htmlFor="inline-full-name"
                >
                  Name
                </label>
              </div>
              <div className="md:w-2/3">
                <input
                  className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                  id="name"
                  name="name"
                  type="text"
                  value={currentSocial.name}
                  required
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3">
                <label
                  className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                  htmlFor="inline-full-name"
                >
                  Link
                </label>
              </div>
              <div className="md:w-2/3">
                <input
                  className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                  id="link"
                  name="link"
                  type="text"
                  value={currentSocial.link}
                  required
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3">
                <label
                  className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                  htmlFor="inline-full-name"
                >
                  Icon
                </label>
              </div>
              <div className="md:w-2/3">
                <input
                  className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                  id="icon"
                  name="icon"
                  type="text"
                  value={currentSocial.icon}
                  required
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </form>

          <div className="md:flex md:items-center">
            <div className="md:w-1/3"></div>
            <div className="md:w-2/3 grid grid-cols-2 gap-40">
              <button
                className="shadow bg-red-500 hover:bg-red-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                onClick={deleteSocial}
              >
                Delete
              </button>

              <button
                className="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                type="submit"
                onClick={updateSocial}
              >
                Update
              </button>
            </div>
          </div>
        </>
      ) : (
        <div>
          <br />
          <p>Please click on a Social...</p>
        </div>
      )}
    </div>
  );
};

export default EditSocial;
